/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
// import { Loading, Message } from 'element-ui'
// import router from './router'
// import Cookies from 'js-cookie';

const env = process.env.NODE_ENV;

//let burl = 'http://api.scsltedu.com/edu'
let burl = env === "development" ? 'http://hengding.constant-newenergy.com/admin' : "http://hengding.constant-newenergy.com/admin"
//let burl = env === "development" ? 'http://localhost:5188/admin' : "http://hdweb.gotoftp3.com/admin"

axios.defaults.baseURL = burl
//axios.defaults.withCredentials = true

// 新建axios拦截器对象
let httpi = axios.create({
  baseURL: burl,
  //withCredentials: true
})

// http请求拦截器

httpi.interceptors.request.use(config => {
  // 站点参数
//   if (Cookies.get('MC_SiteAuthorization')) {
//     config.headers.Authorization = Cookies.get('MC_SiteAuthorization');
//   }
  //element ui Loading方法
  config.headers['Content-Type'] = 'application/json;charset=UTF-8' // 关键所在
  return config
}, error => {
  return Promise.reject(error)
})
// http响应拦截器
httpi.interceptors.response.use(response => {// 响应成功关闭loading
  return response
}, error => {
  console.log(error);
  //router.push({name: 'Error'})
  // return Promise.reject(error)
})

const baseURL = {
    systemurl:burl,
    //fileurl: env === "development" ? 'http://localhost:5199/upload/image/' : 'http://hdweb.gotoftp3.com/upload/image/'
    fileurl: env === "development" ? 'http://www.constant-newenergy.com/upload/image/' : 'http://www.constant-newenergy.com/upload/image/'
}

export {axios,httpi,baseURL}